import { ICampaignStatusServer } from "model/campaigns";
import { ILineitemStatusServer } from "model/lineitems";
import * as R from "ramda";
import { IRootState } from "redux/reducer";
import { createSelector } from "reselect";

export type ICampaignsLineitemStatusServerObject = {
  [campaignId: string]: Omit<ICampaignStatusServer, "lineitems"> & {
    lineitems: {
      [lineitemId: string]: ILineitemStatusServer;
    };
  };
};
export type ILineitemsStatusServerObject = {
  [lineitemId: string]: ILineitemStatusServer;
};

export const getCampaignsStatuses = (
  state: IRootState
): { [campaignId: string]: ICampaignStatusServer } =>
  state.campaignsStatus.data;

export const getStatusesLoadingState = (state) => [
  state.campaignsStatus.loadingState,
  state.campaignsStatus.error,
];

export const getCampaignsLineitemsStatusServerObject = createSelector(
  getCampaignsStatuses,
  (statuses: { [campaignId: string]: ICampaignStatusServer }) => {
    const lineitemsToObject = (c: ICampaignStatusServer) => {
      if (!c.lineitems) return {};

      return {
        ...c,
        lineitems: c.lineitems.reduce((acc, l) => {
          const id = l.lineitemState.id;
          acc[id] = { ...l, id };
          return acc;
        }, {}),
      };
    };

    return R.map(lineitemsToObject, {
      ...statuses,
    }) as ICampaignsLineitemStatusServerObject;
  }
);

export const getLineitemsStatusServerByCampaignId = (campaignId: string) =>
  createSelector(
    getCampaignsStatuses,
    (statuses: { [campaignId: string]: ICampaignStatusServer }) => {
      return statuses[campaignId]?.lineitems;
    }
  );
